import { render, staticRenderFns } from "./patientwaiverr.vue?vue&type=template&id=3d75ee94"
import script from "./patientwaiverr.vue?vue&type=script&lang=js"
export * from "./patientwaiverr.vue?vue&type=script&lang=js"
import style0 from "./patientwaiverr.vue?vue&type=style&index=0&id=3d75ee94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports